import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container'];

  hide() {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add('hidden');
    }
  }

  show() {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove('hidden');
    }
  }

  close() {
    if (this.hasContainerTarget) {
      this.containerTarget.innerHTML = ''
    }
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.close();
    }
  }
}
